// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__eC3lq","image":"Logo_image__z1xsq","name":"Logo_name__8qwvG"};